import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { filter, map, Observable, tap } from 'rxjs';
import { inject } from '@angular/core';

import { LoggerService } from '../../logger/logger.service';
import { ProfileQuery } from 'src/app/profile/state/profile.query';

const loggerName: string = 'HomeGuard';

const HomeGuardFn = (_route: Route, _segments: UrlSegment[]): Observable<boolean> => {
    const logger = inject(LoggerService);
    const profileQuery = inject(ProfileQuery);

    // The homepage is the default landing page for every role.
    // Profile-load gate: wait until role is resolved before activating the route,
    // so HomeDashboardComponent always initialises with a populated profile.
    return profileQuery.select('role').pipe(
        filter(role => role !== undefined),
        map(() => true),
        tap(result => logger.debug(loggerName, `isRouteAllowed: ${result === true}`))
    );
};

export const HomeGuard: CanMatchFn = HomeGuardFn;
